import { baseUrl_SPB } from '../../BaseUrl';

/**
 * Save (create or update) a business customer.
 * Mirrors the React Native AddCustomer.js save flow using
 * POST /api/v1/businesscustomers/save
 */
export default async function SaveBusinessCustomer(customerData, token) {
  const tokenValue = token ? token.toString() : '';
  const response = await fetch(`${baseUrl_SPB}/api/v1/businesscustomers/save`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + tokenValue,
    },
    body: JSON.stringify(customerData),
  });

  if (!response.ok) {
    throw new Error(`Failed to save customer (${response.status})`);
  }

  return response.json();
}
